import { Injectable } from '@angular/core';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent, Analytics } from 'firebase/analytics';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private analytics: Analytics | null = null;
  private ready: Promise<void>;

  constructor() {
    this.ready = this.init();
  }

  private async init(): Promise<void> {
    // No-op until a Firebase Web App is registered and its config pasted into
    // the environment files — same "safe until configured" pattern as the
    // blank Sentry DSN. Also skipped entirely during SSR (isSupported()
    // resolves false there — Analytics needs browser APIs like IndexedDB).
    if (!environment.firebaseConfig.apiKey || !(await isSupported())) {
      return;
    }

    const app: FirebaseApp = initializeApp(environment.firebaseConfig);
    this.analytics = getAnalytics(app);
  }

  logEvent(name: string, params?: Record<string, unknown>): void {
    this.ready.then(() => {
      if (this.analytics) logEvent(this.analytics, name, params);
    });
  }

  logScreenView(screenName: string): void {
    this.logEvent('screen_view', { screen_name: screenName, screen_class: screenName });
  }
}
